import { axios as request } from "../../request/http";


const interfaceUrl = {
    "api_rolesAll": "/roles/queryAll", // 查询所有角色
}

// initial state
const state = {
    rolesAll: [],
}

// getters
const getters = {
    getRolesAll: state => {
        return state.rolesAll
    },

}

// actions
const actions = {
    getRolesAll: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_rolesAll,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('ROLES_ALL', res.data || []);
            } else {
                commit('ROLES_ALL', []);
            }
        }).catch(err => {
            commit('ROLES_ALL', []);
        })
    },
}


// mutations
const mutations = {
    ROLES_ALL: (state, pageData) => {
        state.rolesAll = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/roles.js